import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';
import app from '../app';
import Button from '../../common/components/Button';
import SelectDropdown from '../../common/components/SelectDropdown';
import listItems from '../../common/helpers/listItems';
import LinkButton from '../../common/components/LinkButton';
import classList from '../../common/utils/classList';
export default class IndexSidebar extends Component {
  view(vnode) {
    return m("nav", {
      className: classList('IndexPage-nav sideNav', this.attrs.className)
    }, m("ul", null, listItems(this.items().toArray())));
  }

  /**
   * Build an item list for the sidebar of the index page. By default this is a
   * "New Discussion" button, and then a DropdownSelect component containing a
   * list of navigation items.
   */
  items() {
    const items = new ItemList();
    const canStartDiscussion = app.forum.attribute('canStartDiscussion') || !app.session.user;
    items.add('newDiscussion', m(Button, {
      icon: "fas fa-edit",
      className: "Button Button--primary IndexPage-newDiscussion",
      itemClassName: "App-primaryControl",
      onclick: () => {
        // If the user is not logged in, the promise rejects, and a login modal shows up.
        // Since that's already handled, we dont need to show an error message in the console.
        return this.newDiscussionAction().catch(() => {});
      },
      disabled: !canStartDiscussion
    }, app.translator.trans("core.forum.index.".concat(canStartDiscussion ? 'start_discussion_button' : 'cannot_start_discussion_button'))));
    items.add('nav', m(SelectDropdown, {
      buttonClassName: "Button",
      className: "App-titleControl",
      accessibleToggleLabel: app.translator.trans('core.forum.index.toggle_sidenav_dropdown_accessible_label')
    }, this.navItems().toArray()));
    return items;
  }

  /**
   * Build an item list for the navigation in the sidebar of the index page. By
   * default this is just the 'All Discussions' link.
   */
  navItems() {
    const items = new ItemList();
    const params = app.search.state.stickyParams();
    items.add('allDiscussions', m(LinkButton, {
      href: app.route('index', params),
      icon: "far fa-comments"
    }, app.translator.trans('core.forum.index.all_discussions_link')), 100);
    return items;
  }

  /**
   * Open the composer for a new discussion or prompt the user to login.
   */
  newDiscussionAction() {
    return new Promise((resolve, reject) => {
      if (app.session.user) {
        app.composer.load(() => import(/* webpackChunkName: 'forum/components/DiscussionComposer', webpackMode: 'lazy-once' */ './DiscussionComposer'), {
          user: app.session.user
        }).then(() => app.composer.show());
        return resolve(app.composer);
      } else {
        app.modal.show(() => import(/* webpackChunkName: 'forum/components/LogInModal', webpackMode: 'lazy-once' */ './LogInModal'));
        return reject();
      }
    });
  }
}
flarum.reg.add('core', 'forum/components/IndexSidebar', IndexSidebar);flarum.reg.addChunkModule('814', '1201', 'core', 'forum/components/DiscussionComposer');